import React, { useEffect, useState } from 'react';
import { Modal } from './ui/Modal';
import { Button } from './ui/Button';
import { CalendarClock, XCircle } from 'lucide-react';
interface CancelRescheduleModalProps {
  isOpen: boolean;
  onClose: () => void;
  action: 'cancel' | 'reschedule' | null;
  itemType: 'interview' | 'candidate';
  itemName: string;
  currentDate?: string;
  onConfirm: (data: {
    date?: string;
    note: string;
  }) => void;
}
export function CancelRescheduleModal({
  isOpen,
  onClose,
  action,
  itemType,
  itemName,
  currentDate,
  onConfirm
}: CancelRescheduleModalProps) {
  const [note, setNote] = useState('');
  const [newDate, setNewDate] = useState('');
  const [newTime, setNewTime] = useState('');
  useEffect(() => {
    if (isOpen && currentDate) {
      const d = new Date(currentDate);
      setNewDate(d.toISOString().split('T')[0]);
      setNewTime(d.toTimeString().slice(0, 5));
    } else {
      setNote('');
      setNewDate('');
      setNewTime('');
    }
  }, [isOpen, currentDate]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    let finalDate: string | undefined;
    if (action === 'reschedule') {
      if (!newDate || !newTime) return;
      finalDate = new Date(`${newDate}T${newTime}`).toISOString();
    }
    onConfirm({
      date: finalDate,
      note
    });
    onClose();
  };
  if (!action) return null;
  const isReschedule = action === 'reschedule';
  const title = isReschedule ? `Reschedule ${itemType === 'interview' ? 'Interview' : 'Start Date'}` : `Cancel ${itemType === 'interview' ? 'Interview' : 'Start Date'}`;
  return <Modal isOpen={isOpen} onClose={onClose} title={title} maxWidth="md" data-id="element-175">
      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-176">
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-100 mb-4" data-id="element-177">
          <p className="text-sm text-gray-600" data-id="element-178">
            {isReschedule ? 'Rescheduling' : 'Canceling'} for:
          </p>
          <p className="font-medium text-gray-900" data-id="element-179">{itemName}</p>
        </div>
        {isReschedule && <div className="grid grid-cols-2 gap-4" data-id="element-180">
            <div data-id="element-181">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-182">
                New Date
              </label>
              <input type="date" required value={newDate} onChange={e => setNewDate(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent" data-id="element-183" />
            </div>
            <div data-id="element-184">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-185">
                New Time
              </label>
              <input type="time" required value={newTime} onChange={e => setNewTime(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent" data-id="element-186" />
            </div>
          </div>}
        <div data-id="element-187">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-188">
            Reason for {isReschedule ? 'rescheduling' : 'cancellation'}{' '}
            <span className="text-red-500" data-id="element-189">*</span>
          </label>
          <textarea required value={note} onChange={e => setNote(e.target.value)} rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent resize-none" placeholder={`Please provide a reason for this ${isReschedule ? 'change' : 'cancellation'}...`} data-id="element-190" />
        </div>
        <div className="flex justify-end gap-3 pt-4" data-id="element-191">
          <Button variant="secondary" type="button" onClick={onClose} data-id="element-192">
            Close
          </Button>
          <Button variant={isReschedule ? 'primary' : 'danger'} type="submit" leftIcon={isReschedule ? <CalendarClock className="w-4 h-4" data-id="element-194" /> : <XCircle className="w-4 h-4" data-id="element-195" />} data-id="element-193">
            {isReschedule ? 'Confirm Reschedule' : 'Confirm Cancellation'}
          </Button>
        </div>
      </form>
    </Modal>;
}